module.exports = __webpack_public_path__ + "20ba32b5e454b1fd078dc209902013e2.png";


//////////////////
// WEBPACK FOOTER
// ./images/profile-icon.png
// module id = 508
// module chunks = 0